export enum Role {
  Admin = "ADMIN",
  ManagedUser = "MANAGED",
  StandaloneUser = "STANDALONE",
  Client = "CLIENT",
  Guest = "GUEST",
}
